import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { DataList, ToggleSwitch, noRowsDefault } from 'common/components';

import { SYNC_HISTORY_HEADER_TITLE, getSyncLogsListColDefs } from 'modules/sync-history/config';
import { SyncLogRequest } from 'modules/sync-history/models/sync-history.model';
import { syncHistoryActions } from 'modules/sync-history/redux';
import { RootState } from 'common/redux/core/root.reducer';
import {
    syncLogDataPaginationSelector,
    syncLogDataSelector,
    syncLogDataStatusSelector
} from 'modules/sync-history/redux/sync-history.selector';
import { ApiStatus } from 'common/enums';

import './SyncHistory.scss';
import useSyncHistoryStatusAccess from 'modules/sync-history/role-access-hooks/useSyncHistoryAccess';

const SyncHistory: FC = () => {
    const dispatch = useDispatch();

    const [syncHistoryRequest, setSyncHistoryRequest] = useState<SyncLogRequest>({
        pageNumber: 1,
        pageSize: 20,
        searchText: '',
        isMine: false,
        status: 1
    });

    const syncLogData = useSelector((state: RootState) => syncLogDataSelector(state));
    const syncLogDataStatus = useSelector((state: RootState) => syncLogDataStatusSelector(state));
    const syncLogDataPagination = useSelector((state: RootState) =>
        syncLogDataPaginationSelector(state)
    );

    useEffect(() => {
        dispatch(syncHistoryActions.fetchSyncLogs(syncHistoryRequest));
    }, [dispatch, syncHistoryRequest]);

    const toggleIsMine = (event: React.ChangeEvent<HTMLInputElement>) => {
        const updatedRequest: SyncLogRequest = {
            ...syncHistoryRequest,
            pageNumber: 1,
            isMine: event.target.checked
        };
        setSyncHistoryRequest(updatedRequest);
    };

    /**
     * To handle infinite scroll
     */
    const handleScroll = () => {
        if (
            syncLogDataStatus !== ApiStatus.LOADING &&
            syncLogDataPagination &&
            syncLogDataPagination.totalPages > syncHistoryRequest.pageNumber
        ) {
            const updatedRequest: SyncLogRequest = { ...syncHistoryRequest };
            updatedRequest.pageNumber = updatedRequest.pageNumber + 1;
            setSyncHistoryRequest(updatedRequest);
            dispatch(syncHistoryActions.fetchSyncLogs(updatedRequest));
        }
    };

    //const { isSyncHistoryStatusDisabled } = useSyncHistoryStatusAccess();
    return (
        <div className="route-container">
            <div className={`data-editor-header-container`}>
                <div className={`data-editor-header header-default`}>
                    {SYNC_HISTORY_HEADER_TITLE}
                </div>
                <div className="header-right">
                    <ToggleSwitch
                        className="toggle-switch"
                        id="mySyncs"
                        checked={syncHistoryRequest.isMine}
                        name=""
                        hideLabels={false}
                        value={'My triggers'}
                        onLabel=""
                        offLabel={'My triggers'}
                        onChange={toggleIsMine}
                    />
                </div>
            </div>
            <div className="sync-logs-list-wrapper">
                <DataList
                    isNoDataVisible={syncLogData.length === 0}
                    data={syncLogData}
                    noRowsTemplate={noRowsDefault}
                    fetchNextDataSet={handleScroll}
                    columnDefs={getSyncLogsListColDefs(syncLogData)}
                />
            </div>
        </div>
    );
};

export default SyncHistory;
